// extracted by mini-css-extract-plugin
export default {"aboutText":"aboutUs_aboutText__akb2W","aboutCont":"aboutUs_aboutCont__QopXl","linkCont":"aboutUs_linkCont__wtbDD","linkText":"aboutUs_linkText__lJJVC"};